import useActivation from '@/src/Activations/components/hooks/useActivation';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import SmallLoader from '@/src/Common/components/SmallLoader';
import useGetGalleries from '@/src/GalleryConfiguration/components/hooks/useGetGalleries';
import useWhitelabelSettings from '@/src/WhitelabelSettings/components/hooks/useWhitelabelSettings';
import { format } from 'date-fns';
import { GalleryThumbnailsIcon } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function ActivationStatusCard({
    activationId,
    activationName,
    createdAt,
}: {
    activationId: string;
    activationName: string;
    createdAt: Date;
}) {
    const [isLoading, setIsLoading] = useState(true);
    const { getGalleriesForActivation } = useGetGalleries();
    const [, setGalleries] = useState<any[]>([]);
    const { getOrgDomain } = useWhitelabelSettings();
    const { org } = useUserOrg();
    const [galleryUrl, setGalleryUrl] = useState<string | null>(null);
    const [mediaCount, setMediaCount] = useState<number>(0);
    const { getActivationPhotos } = useActivation();

    useEffect(() => {
        getGalleriesForActivation(+activationId).then(async (galleries) => {
            setGalleries(galleries);
            const gallery = galleries[0];
            const galleryUrl = await getOrgDomain(org?.id);

            // Ensure the baseUrl doesn't have a trailing slash to avoid double slashes
            const cleanGalleryUrl = galleryUrl
                ? galleryUrl.endsWith('/')
                    ? galleryUrl.slice(0, -1)
                    : galleryUrl
                : null;

            const fullGalleryUrl = galleryUrl
                ? `${cleanGalleryUrl}/gallery/${encodeURIComponent(
                      gallery.slug,
                  )}`
                : `/gallery/${encodeURIComponent(gallery.slug)}`;
            setGalleryUrl(fullGalleryUrl);
            setIsLoading(false);
        });

        getActivationPhotos(+activationId, []).then((photos: any[]) => {
            setMediaCount(photos.length);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-muted/50 border border-border rounded-lg p-3 text-center">
            <a href={`/activations/${activationId}`} className="block">
                <p className="text-sm font-medium text-foreground truncate">
                    {activationName}
                </p>
            </a>
            <p className="text-xs text-muted-foreground mt-1">
                {format(createdAt, 'Pp')}
            </p>
            {isLoading ? (
                <SmallLoader />
            ) : (
                <div className="flex items-center justify-center mt-2 ">
                    <div
                        onClick={() => {
                            window.open(galleryUrl || '', '_blank');
                        }}
                    >
                        <GalleryThumbnailsIcon className="w-4 h-4 cursor-pointer" />
                    </div>
                    <p className="text-xs text-muted-foreground mt-1 ml-2 mb-1">
                        {mediaCount} uploads
                    </p>
                </div>
            )}
        </div>
    );
}
